<template>
    <div class="rubric-cell">
        <b-form-textarea
            class="apprentice-textarea"
            v-if="getCellValue() === ''"
            rows="5"
            :placeholder="$t('common.description')"
            :value="getCellValue()"
            disabled>
        </b-form-textarea>

        <design-2021-apprentice-display-html-component
            v-else
            :html-content="getCellValue()"
        ></design-2021-apprentice-display-html-component>

        <div
            class="rubric-cell-content-value"
            @click="showColumnCellContentEditModal">
            <i class="fas fa-fw fa-pencil rubric-cell-edit-content"></i>
        </div>
        <design-2021-rubric-edit-column-cell-content-edit-modal-component
            ref="rubric-column-cell-content-edit"
            :columnIn="columnIn"
            :row-id="rowId">
        </design-2021-rubric-edit-column-cell-content-edit-modal-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-rubric-edit-column-cell-component',
    props: {
        columnIn: Object,
        rowId: Number
    },

    methods: {
        getCellValue() {
            const cell = this.columnIn.getCellForRow(this.rowId);
            return cell ? cell.value : '';
        },

        showColumnCellContentEditModal() {
            const name = `rubric-column-cell-content-edit`;
            this.$refs[name].show();
        }
    }
};
</script>

<style scoped lang="scss">
.rubric-cell {
    position: relative;
    padding: map-get($grid-gutter-spacing, 'fifteen');
    border: 2px solid transparent;
    background-color: rgba($secondary-background-color, 0.25);

    textarea {
        margin-bottom: 0;
        font-size: $default-font-size;
        background-color: $white;
        border: 1px solid $border-color;
        min-width: 150px;
        width: 100%;
        overflow: hidden;

        &::-webkit-input-placeholder {
            text-align: center;
            height: 100%;
            transform: translateY(45%);
            overflow: hidden;
        }

        &:-moz-placeholder {
            /* Firefox 18- */
            text-align: center;
            height: 100%;
            transform: translateY(45%);
            overflow: hidden;
        }

        &::-moz-placeholder {
            /* Firefox 19+ */
            text-align: center;
            height: 100%;
            transform: translateY(45%);
            overflow: hidden;
        }

        &:-ms-input-placeholder {
            text-align: center;
            transform: translateY(45%);
            height: 100%;
            overflow: hidden;
        }
    }

    .rubric-cell-content-value {
        position: absolute;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        color: $primary;
        opacity: 0;

        i {
            font-size: 1.3125rem;
        }
    }

    &:hover {
        border-color: $primary;
        cursor: pointer;

        .rubric-cell-content-value {
            opacity: 1;
        }
    }
}
</style>
